<template>
  <div class="score-page">
    <login-after-head-center></login-after-head-center>
    <div id="member" class="container center-container flex">
      <side-nav></side-nav>
      <main class="detail-main" v-loading="loading">
        <div class="detail-title fc-bet">
          <span>积分订单详情</span>
          <button type="button" @click="backToOrders">返回积分订单</button>
        </div>
        <template v-if="order.id">
          <div v-if="orderStatus && order.refundStatus === 0" class="steps-wrap">
            <el-steps :active="orderStatus.size" align-center process-status="process" finish-status="success">
              <el-step title="客户下单" :description="orderStatus.cacheKeyCreateOrder"></el-step>
              <el-step title="确认订单" :description="orderStatus.confirmOrder"></el-step>
              <el-step title="待收货" :description="orderStatus.deliveryGoods"></el-step>
              <el-step title="已完成" :description="orderStatus.checkOrderOver"></el-step>
            </el-steps>
          </div>
          <div v-else-if="orderStatus" class="steps-wrap">
            <el-steps :active="order.refundStatus + 1" align-center process-status="process" finish-status="success">
              <el-step title="用户下单" :description="orderStatus.cacheKeyCreateOrder"></el-step>
              <el-step title="申请退款" :description="orderStatus.applyRefund"></el-step>
              <el-step title="退款完成" :description="refundSuccessTime"></el-step>
            </el-steps>
          </div>

          <div class="status-box">
            <div>当前订单状态：<span>{{ getStatus(order) }}</span></div>
            <div class="status-actions">
              <button
                v-if="canTakeOrder"
                type="button"
                class="integral-action-button take-order-button"
                :disabled="takingOrder"
                @click="takeOrder"
              >
                {{ takingOrder ? '确认中...' : '确认收货' }}
              </button>
            </div>
          </div>
          <section class="info-section">
            <h2>基本信息</h2>
            <div class="info-grid">
              <div><span>订单编号</span><strong>{{ order.orderId || '--' }}</strong></div>
              <div><span>订单类型</span><strong>积分兑换</strong></div>
              <div><span>支付方式</span><strong>{{ order.payTypeName || '积分兑换' }}</strong></div>
              <div><span>物流公司</span><strong>{{ order.deliveryName || '暂未发货' }}</strong></div>
              <div><span>物流单号</span><strong>{{ order.deliveryId || '暂未发货' }}</strong></div>
              <div><span>消耗积分</span><strong class="point-text">{{ order.payIntegral || 0 }} 积分</strong></div>
            </div>
          </section>

          <section class="info-section">
            <h2>收货人信息</h2>
            <div class="info-grid receiver-grid">
              <div><span>收货人</span><strong>{{ order.realName || '--' }}</strong></div>
              <div><span>手机号码</span><strong>{{ order.userPhone || '--' }}</strong></div>
              <div><span>收货地址</span><strong>{{ order.userAddress || '--' }}</strong></div>
              <div><span>用户备注</span><strong>{{ order.mark || '--' }}</strong></div>
            </div>
          </section>

          <section class="info-section">
            <h2>商品信息</h2>
            <el-table :data="order.cartInfoList || []" size="small" border @row-click="viewProduct">
              <el-table-column label="商品图片" width="120" align="center">
                <template slot-scope="scope">
                  <img class="table-product-image" :src="productImage(scope.row)" alt="积分商品">
                </template>
              </el-table-column>
              <el-table-column label="商品名称" min-width="220">
                <template slot-scope="scope">
                  {{ productName(scope.row) }}
                  <span v-if="isSeckillItem(scope.row)" class="seckill-order-tag">秒杀</span>
                </template>
              </el-table-column>
              <el-table-column label="规格" min-width="180">
                <template slot-scope="scope">{{ productSku(scope.row) }}</template>
              </el-table-column>
              <el-table-column label="积分单价" width="120" align="center">
                <template slot-scope="scope">
                  {{ isSeckillItem(scope.row) ? '秒杀' : '积分' }}{{ itemPointPrice(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="数量" width="90" align="center">
                <template slot-scope="scope">{{ scope.row.cartInfoMap && scope.row.cartInfoMap.cartNum || 0 }}</template>
              </el-table-column>
              <el-table-column label="小计积分" width="130" align="center">
                <template slot-scope="scope">
                  {{ itemPointPrice(scope.row) * ((scope.row.cartInfoMap && scope.row.cartInfoMap.cartNum) || 0) }}
                </template>
              </el-table-column>
            </el-table>
            <div class="total-points">共{{ totalItems }}件&nbsp;&nbsp;总计：<strong>{{ order.payIntegral || 0 }}积分</strong></div>
          </section>
        </template>
        <div v-else-if="!loading" class="empty-detail">订单不存在或无权查看</div>
      </main>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import {
  getNowOrderStatus,
  getOrderDetail,
  takeOrder as takeOrderRequest
} from '@/api/order'

const STATUS = {
  1: '待付款',
  2: '待发货',
  3: '退款中',
  4: '待收货',
  5: '待评价',
  6: '已完成',
  7: '已退款',
  8: '待确认'
}

export default {
  name: 'IntegralOrderDetail',
  data () {
    return {
      order: {},
      orderStatus: null,
      loading: true,
      takingOrder: false
    }
  },
  mounted () {
    this.loadOrderDetail()
  },
  computed: {
    canTakeOrder () {
      return Number(this.order._status) === 4 && Number(this.order.paid) === 1 &&
        Number(this.order.shippingType) === 1 && Number(this.order.refundStatus || 0) === 0
    },
    refundSuccessTime () {
      if (this.orderStatus && this.orderStatus.refundOrderSuccess) {
        return this.orderStatus.refundOrderSuccess
      }
      const statusList = this.order.storeOrderStatusList || []
      const refundStatus = statusList.find(item => {
        return item.changeMessage && item.changeMessage.indexOf('退款给用户') >= 0
      })
      return refundStatus ? refundStatus.changeTime : ''
    },
    totalItems () {
      return (this.order.cartInfoList || []).reduce((total, row) => {
        const cartInfo = row.cartInfoMap || {}
        return total + Number(cartInfo.cartNum || 0)
      }, 0)
    }
  },
  methods: {
    loadOrderDetail () {
      const id = this.$route.query.orderId
      if (!id) {
        this.loading = false
        return Promise.resolve()
      }
      this.loading = true
      return Promise.all([getOrderDetail(id), getNowOrderStatus(id)]).then(([orderRes, statusRes]) => {
        this.order = orderRes.data || {}
        this.orderStatus = statusRes.data || null
      }).catch(error => {
        this.$message.warning((error && error.msg) || '积分订单加载失败，请重试')
      }).finally(() => {
        this.loading = false
      })
    },
    takeOrder () {
      if (!this.canTakeOrder || this.takingOrder) return
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.takingOrder = true
        return takeOrderRequest({ uni: this.order.orderId })
      }).then(() => {
        this.$message.success('收货成功!')
        return this.loadOrderDetail()
      }).catch(error => {
        if (error === 'cancel' || error === 'close') return
        this.$message.warning((error && error.msg) || '确认收货失败，请重试')
      }).finally(() => {
        this.takingOrder = false
      })
    },
    backToOrders () {
      this.$router.push('/integralOrders')
    },
    getStatus (order) {
      const status = Number(order && order._status)
      return STATUS[status] || order.statusName || '状态未知'
    },
    cartInfo (row) {
      return row && row.cartInfoMap ? row.cartInfoMap : {}
    },
    productInfo (row) {
      return this.cartInfo(row).productInfo || {}
    },
    productImage (row) {
      const product = this.productInfo(row)
      const attrInfo = product.attrInfo || {}
      return attrInfo.image || product.image || require('../assets/noll.png')
    },
    productName (row) {
      const product = this.productInfo(row)
      return product.storeName || '--'
    },
    productSku (row) {
      const product = this.productInfo(row)
      const attrInfo = product.attrInfo || {}
      return attrInfo.skuName || product.storeInfo || '--'
    },
    isSeckillItem (row) {
      const cartInfo = this.cartInfo(row)
      const product = this.productInfo(row)
      const attrInfo = product.attrInfo || {}
      return Number(cartInfo.seckillId) > 0
    },
    itemPointPrice (row) {
      const product = this.productInfo(row)
      const attrInfo = product.attrInfo || {}
      if (this.isSeckillItem(row)) return Number(attrInfo.seckillIntegral)
      return Number(attrInfo.integral || product.integral || 0)
    },
    viewProduct (row) {
      const cartInfo = this.cartInfo(row)
      const product = this.productInfo(row)
      const productId = cartInfo.productId || product.id
      if (!productId) {
        this.$message.info('商品信息已失效')
        return
      }
      this.$router.push({ path: '/scoreDetails', query: { id: productId } })
    }
  }
}
</script>

<style scoped lang="less">
.center-container {
  align-items: flex-start;
  gap: 20px;
  padding: 30px 0;
}
.detail-main {
  flex: 1;
  min-height: 580px;
  padding: 24px;
  border: 1px solid #eee;
  background: #fff;
}
.detail-title {
  padding-bottom: 18px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 18px;
}
.detail-title button {
  border: 0;
  background: transparent;
  color: #57aca7;
  cursor: pointer;
}
.steps-wrap {
  padding: 28px 10px 18px;
}
.status-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  background: #f7fbfa;
  color: #555;
}
.status-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.status-actions .integral-action-button,
.status-actions .integral-action-button:hover,
.status-actions .integral-action-button:focus,
.status-actions .integral-action-button:active {
  -webkit-appearance: none;
  appearance: none;
  min-width: 96px;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #57aca7 !important;
  border-radius: 4px;
  outline: 0;
  color: #fff !important;
  background: #57aca7 !important;
  cursor: pointer;
  font: inherit;
  line-height: 30px;
  text-align: center;
}
.status-actions .integral-action-button:disabled {
  color: #fff !important;
  background: #9bc9c6 !important;
  border-color: #9bc9c6 !important;
  cursor: not-allowed;
  opacity: 1;
}
.status-box /deep/ b,
.status-box /deep/ span {
  color: #57aca7;
}
.info-section {
  margin-top: 24px;
}
.info-section h2 {
  margin-bottom: 12px;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.info-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
}
.info-grid div {
  min-height: 64px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  text-align: center;
}
.info-grid span,
.info-grid strong {
  display: block;
  padding: 8px;
}
.info-grid span {
  background: #f7f8f8;
  color: #666;
  font-size: 13px;
}
.info-grid strong {
  overflow: hidden;
  color: #333;
  font-size: 13px;
  font-weight: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.receiver-grid {
  grid-template-columns: repeat(4, 1fr);
}
.point-text,
.total-points strong {
  color: #57aca7 !important;
}
.info-section /deep/ .el-table__body-wrapper tbody tr {
  cursor: pointer;
}
.seckill-order-tag {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 5px;
  background: #e43d33;
  color: #fff;
  font-size: 12px;
}
.table-product-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
}
.total-points {
  padding-top: 18px;
  text-align: right;
}
.total-points strong {
  font-size: 20px;
}
.empty-detail {
  padding: 160px 0;
  color: #999;
  text-align: center;
}
</style>
